import React, { useEffect, useMemo } from 'react';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import TotalIncidents from './TotalIncidents';
import IncidentTrends from './IncidentTrends';
import ResponseEfficiency from './ResponseEfficiency';
import IncidentImpact from './IncidentImpact';
import { useDispatch, useSelector } from 'react-redux';
import { getFilterParams } from '../../components/Incidents/FilterOverview/useFiltersUrlState';
import { useSearchParams } from 'react-router-dom';
import { getDepartmentsList } from '../../store/incidentsReducer';
import { getIncidentsOverview } from '../../store/incidentsPerformanceReducer';
import moment from 'moment';

const Overview = () => {
  const dispatch = useDispatch();
  const [params] = useSearchParams();

  const { chartsData, loading } = useSelector(
    (state) => state.incidentsPerformanceReducer
  );

  // init fetch
  useEffect(() => {
    const params = getFilterParams();
    dispatch(
      getIncidentsOverview({
        ...params,
      })
    );
    dispatch(getDepartmentsList());
  }, [dispatch]);

  const dateRange = useMemo(() => {
    const dateRangeFilter = getFilterParams(params);
    if (dateRangeFilter.start_dt && dateRangeFilter.end_dt) {
      // return day diff
      return (
        moment(dateRangeFilter.end_dt).diff(moment(dateRangeFilter.start_dt), 'days')
      );
    }
    return null;
  }, [params]);

  return (
    <Box className="mt-4">
      {loading ? (
        <Box
          sx={{ minHeight: '100px' }}
          className="w-100 h-100 d-flex justify-content-center align-items-center"
        >
          <CircularProgress />
        </Box>
      ) : !loading && Object.keys(chartsData).length === 0 ? (
        <Typography className="mt-2" color="#6E7C87">
          No data search.
        </Typography>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TotalIncidents dateRange={dateRange} data={chartsData} />
          </Grid>
          <Grid item xs={12}>
            <IncidentTrends data={chartsData} />
          </Grid>
          <Grid item xs={12}>
            <ResponseEfficiency dateRange={dateRange} data={chartsData} />
          </Grid>
          <Grid item xs={12}>
            <IncidentImpact />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Overview;
